import styled from 'styled-components'
import { Title as DefaultTitle } from '~components'
import DefaultRow from '~components/dumbs/Row'

export const Title = styled(DefaultTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`

export const RadioGroup = styled.fieldset`
  border: none;
`

export const Row = styled(DefaultRow)`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column;
  }
`

export const Form = styled.form`
    width: 448px;
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: auto;
    position: initial;
    left: unset;
    transform: unset;
    align-items: unset;
  }
`
